import { useRef } from "react";
import { AppTooltip } from "../../shared/components/AppTooltip";
import { InfoIcon } from "../../shared/icons/InfoIcon";
import { TooltipProps } from "@mui/material";
import styles from "./styles.module.css";

interface Props extends Omit<TooltipProps, "title" | "children"> {
  title: string;
  place:
    | "top"
    | "bottom-end"
    | "bottom-start"
    | "bottom"
    | "left-end"
    | "left-start"
    | "left"
    | "right-end"
    | "right-start"
    | "right"
    | "top-end"
    | "top-start"
    | undefined;
  className?: string;
}

export const AppInfoTooltip = ({ title, place, className }: Props) => {
  const ref = useRef<HTMLDivElement | null>(null);

  return (
    <AppTooltip title={title} placement={place}>
      <div ref={ref} className={className}>
        <InfoIcon />
      </div>
    </AppTooltip>
  );
};
